import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat"
import LocationOnIcon from "@mui/icons-material/LocationOn"

import MapInfoCard from "@/components/map/MapInfoCard.jsx"
import VesselCardContent from "@/features/vessel/VesselCardContent.jsx"
import WaypointCardBody from "@/features/route/WaypointCardBody.jsx"
import WaypointDeleteAction from "@/features/route/WaypointDeleteAction.jsx"
import { findCardColor, waypointLabel } from "@/utils/routeHelper.jsx"
import { useIsCalculating } from "@/features/route/state/RouteStore.jsx"

// Rendert die Info-Karte (Vessel oder Waypoint) zum aktiven Klickziel.
export default function ActiveInfoCard({ activeCard, onClose }) {
  const isCalculating = useIsCalculating()
  if (!activeCard?.data) return null

  if (activeCard.type === "vessel") {
    const vesselRouteType =
      activeCard.data?.routeType ??
      activeCard.data?.geojson?.features?.[0]?.properties?.routeType
    const vesselState =
      activeCard.data?.state ??
      activeCard.data?.geojson?.features?.[0]?.properties?.state
    const color = findCardColor(vesselRouteType, vesselState)
    return (
      <MapInfoCard
        anchorLatLng={activeCard.anchor}
        onClose={onClose}
        title={activeCard.data?.vesselName ?? "Vessel"}
        icon={<DirectionsBoatIcon sx={{ color, fontSize: 16 }} />}
        headerColor={color}
      >
        <VesselCardContent selectedVessel={activeCard.data} />
      </MapInfoCard>
    )
  }

  if (activeCard.type === "waypoint") {
    const edit = activeCard.edit
    const color = findCardColor(
      activeCard.routeType,
      activeCard.state ?? activeCard.data?.properties?.state,
    )
    return (
      <MapInfoCard
        anchorLatLng={activeCard.anchor}
        onClose={onClose}
        title={
          activeCard.vesselName ??
          activeCard.data?.properties?.vesselName ??
          activeCard.data?.properties?.routeName ??
          "Waypoint"
        }
        subtitle={`${
          activeCard.label ?? edit?.label ?? waypointLabel(activeCard.data?.properties)
        }${activeCard.leg ? ` → ${activeCard.leg.toLabel}` : ""}`}
        icon={<LocationOnIcon sx={{ color, fontSize: 16 }} />}
        headerColor={color}
        actions={
          edit?.onDelete ? (
            <WaypointDeleteAction
              onDelete={edit.onDelete}
              label={edit.deleteLabel}
              disabled={isCalculating}
            />
          ) : null
        }
      >
        <WaypointCardBody
          feature={activeCard.data}
          routeType={activeCard.routeType}
          sketch={edit?.sketch}
          edit={edit ? { ...edit, disabled: isCalculating } : null}
        />
      </MapInfoCard>
    )
  }

  return null
}
